import {OnOffTrigger, TimeWindowCondition, type TriggerCondition, type TriggerFactory} from "./triggers";

export class ClickTrigger extends OnOffTrigger {
    public constructor(private element: Element, triggerConditions: TriggerCondition[], callback: () => void) {
        super(triggerConditions, callback);

        this.element.addEventListener("click", event => {
            event.preventDefault();
            this.trigger();
        });
    }
}

export class ClickTriggerFactory implements TriggerFactory {

    public createTrigger(element: Element, callback: () => void): ClickTrigger {
        return new ClickTrigger(element, TimeWindowCondition.timeWindowCondition(element), callback);
    }
}